"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _StackedBarChart = require("./StackedBarChart");
Object.keys(_StackedBarChart).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _StackedBarChart[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _StackedBarChart[key];
    }
  });
});